import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function PieAndDoughnutChart() {
  const data = {
    labels: ['Desktop', 'Mobile', 'Tablet'],
    datasets: [
      {
        label: 'Device Usage',
        data: [1200, 450, 300], // فقط 3 عناصر
        backgroundColor: ['#01a9fc', '#a6d7f9', '#23cebc'],
        borderColor: '#fff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
      cutout: '70%',
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <div>
      <div style={{ width: '150px' }}>
        <Doughnut data={data} options={options} />
      </div>
    </div>
  );
}

export default PieAndDoughnutChart;
